import { useMemo } from "react";
import { usePagination } from "../../../../hooks/usePagination";
import { COLLECTIONS } from "../../../../services/collections";
import { FINANCIAL_STATUS, FINANCIAL_TYPES } from "../../../../constants/financial";

export const useCashierRecords = (idTenant, user, selectedDate, currentShift, canViewAllCashier) => {
    // 1. Filtros para financialRecords vinculados ao Turno ou Operador
    const firestoreFilters = useMemo(() => {
        if (currentShift?.id) {
            return [
                { field: "idCashierShift", operator: "==", value: currentShift.id }
            ];
        }

        if (!canViewAllCashier) {
            return [
                { field: "status", operator: "==", value: FINANCIAL_STATUS.PAID },
                { field: "paymentDate", operator: "==", value: selectedDate },
                { field: "idEmployee", operator: "==", value: user?.uid || "__no_user__" },
            ];
        }

        return [
            { field: "status", operator: "==", value: FINANCIAL_STATUS.PAID },
            { field: "paymentDate", operator: "==", value: selectedDate },
        ];
    }, [canViewAllCashier, selectedDate, currentShift, user]);

    // 2. Paginação Genérica do Firestore
    const {
        data: backendRecords,
        loading,
        error,
        refresh,
    } = usePagination(
        `tenants/${idTenant}/${COLLECTIONS.FINANCIAL_RECORDS}`,
        idTenant,
        {
            pageSize: 500,
            orderField: currentShift?.id ? "idCashierShift" : "paymentDate",
            orderDirection: "desc",
            filters: firestoreFilters,
        }
    );

    // 3. Ordenação Local e Pureza: Blindagem de Fallback (Somente ASSET / LIABILITY)
    const records = useMemo(() => {
        if (!backendRecords || backendRecords.length === 0) return [];
        return backendRecords
            .filter(r => r.type === FINANCIAL_TYPES.ASSET || r.type === FINANCIAL_TYPES.LIABILITY)
            .sort((a, b) => {
                const timeA = a.createdAt?.toDate ? a.createdAt.toDate().getTime() : 0;
                const timeB = b.createdAt?.toDate ? b.createdAt.toDate().getTime() : 0;
                return timeB - timeA;
            });
    }, [backendRecords]);

    // 4. Resumo Calculado
    const summary = useMemo(() => {
        let totalIncome = 0;
        let totalExpense = 0;

        records.forEach(r => {
            if (r.type === FINANCIAL_TYPES.ASSET) totalIncome += r.netAmount || 0;
            if (r.type === FINANCIAL_TYPES.LIABILITY) totalExpense += r.netAmount || 0;
        });

        return {
            totalIncome,
            totalExpense,
            balanceOfDay: totalIncome - totalExpense,
        };
    }, [records]);

    return { records, summary, loading, error, refresh };
};
